<template>
  <!-- Image of the part number (assembly item) of the work order. Nothing is rendered unless the image loads:
       a part number without image gives a 404 and the broken-image icon never shows. -->
  <div v-if="itemId && !failed" class="part-image">
    <v-dialog v-model="enlarged" max-width="900">
      <template v-slot:activator="{ on, attrs }">
        <button v-show="loaded" type="button" class="part-image__thumb" v-bind="attrs" v-on="on" :aria-label="'Enlarge the image of part number ' + partNumber">
          <img :src="src" :alt="'Image of part number ' + partNumber" @load="loaded = true" @error="failed = true" />
        </button>
      </template>
      <v-card>
        <img :src="src" :alt="'Image of part number ' + partNumber" class="part-image__large" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="enlarged = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const API_URL = process.env.VUE_APP_BACKEND;

export default {
  name: "PartImage",
  props: {
    // Internal id of the assembly item (workorder.assembly_item_id)
    itemId: { type: [Number, String], default: null },
    partNumber: { type: String, default: "" },
  },
  data: () => ({
    loaded: false,
    failed: false,
    enlarged: false,
  }),
  computed: {
    src() {
      return `${API_URL}/item-image/${this.itemId}`;
    },
  },
  watch: {
    // A new work order: forget the previous result so a failed image does not hide the next one
    itemId() {
      this.loaded = false;
      this.failed = false;
      this.enlarged = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.part-image__thumb {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;          /* antes: 500px */
  max-width: 560px;     /* nuevo */
  height: 480px;        /* antes: 200px */
  max-height: 60vh;     /* nuevo: en pantallas bajas no se pasa de alto */
  margin: 20px auto 0;  /* antes: 10px 0 0; ahora centrada en la columna */
  padding: 4px;
  background: #fff;
  border: solid 1px whitesmoke;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  cursor: zoom-in;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
}
.part-image__large {
  display: block;
  max-width: 100%;
  max-height: 80vh;
  margin: 0 auto;
  object-fit: contain;
}
</style>
